import ko from 'knockout';
import _ from 'underscore';
import {
  formatCost,
  CONTEXTUAL_DELIVERY_STATUS,
} from '@bingads-webui-campaign/recommendation-core';

export default class ViewModel {
  constructor({
    i18n,
  }) {
    this.i18n = i18n;
    this.campaignDeliveryStatusTitle = ko.observable('');
    this.campaignDeliveryStatus = ko.observable('');
    this.campaignType = ko.observable('');
    this.campaignBudget = ko.observable('');
    this.campaignBiddingType = ko.observable('');
    this.eligibleStatusIcon = ko.observable(false);
    this.showStatusIcon = ko.observable(false);
  }

  updateAttribute({
    campaignDeliveryStatus,
    campaignType,
    campaignBudget,
    campaignBiddingType,
  }) {
    const { i18n } = this;
    this.campaignDeliveryStatusTitle(i18n.getString('Campaign_Delivery_Status'));
    this.campaignDeliveryStatus(_.contains(CONTEXTUAL_DELIVERY_STATUS, campaignDeliveryStatus) ?
      i18n.getString(`Label_DeliveryStatus_${campaignDeliveryStatus}`) :
      i18n.getString('Contextual_Response_Null'));
    this.campaignType(i18n.getString('Campaign_Type', {
      campaignType: campaignType ?
        i18n.getString(`CampaignType_${campaignType}`) :
        i18n.getString('Contextual_Response_Null'),
    }));
    this.campaignBudget(i18n.getString('Campaign_Budget', {
      campaignBudget: campaignBudget ?
        i18n.getString('Campaign_Budget_Value', {
          campaignBudget: formatCost(campaignBudget, i18n, i18n.currency),
        }) :
        i18n.getString('Contextual_Response_Null'),
    }));
    this.campaignBiddingType(i18n.getString('Campaign_Bidding_Type', {
      campaignBiddingType: campaignBiddingType ?
        i18n.getString(`BidStrategy_${campaignBiddingType}`) :
        i18n.getString('Contextual_Response_Null'),
    }));

    if (this.campaignDeliveryStatus() !== i18n.getString('Contextual_Response_Null')) {
      this.showStatusIcon(true);
    }
    if (this.campaignDeliveryStatus() === i18n.getString('EntityStatus_Eligible')) {
      this.eligibleStatusIcon(true);
    }
  }
}
